var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductionValue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.867 7.267c-1.514-.394-2-.8-2-1.434 0-.726.673-1.233 1.8-1.233.946 0 1.42.36 1.593.933.08.267.3.467.58.467h.2c.44 0 .753-.433.6-.847-.28-.786-.933-1.44-1.973-1.693V3c0-.553-.447-1-1-1-.554 0-1 .447-1 1v.44c-1.294.28-2.334 1.12-2.334 2.407 0 1.54 1.274 2.306 3.134 2.753 1.666.4 2 .987 2 1.607 0 .46-.327 1.193-1.8 1.193-1.1 0-1.667-.393-1.887-.953-.1-.26-.327-.447-.6-.447h-.187a.636.636 0 0 0-.593.867c.38.926 1.267 1.473 2.267 1.686V13c0 .553.446 1 1 1 .553 0 1-.447 1-1v-.433c1.3-.247 2.333-1 2.333-2.367 0-1.893-1.62-2.54-3.133-2.933z",
    fill: "#8CAEB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionValue);
export default __webpack_public_path__ + "static/media/production-value.4f1e65ca3683dcff6f6f4462484ba32a.svg";
export { ForwardRef as ReactComponent };